import './App.css';

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';

import Footer from "./components/inc/Footer";
import Home from "./components/pages/Home";
import Governing from './components/pages/Governing';
import Contactus from './components/pages/Contactus';
import Pancard from './components/pages/Pancard';
import About from './components/pages/About';
import Deed from './components/pages/Deed';
import LandDetails from './components/pages/LandDetails';
import Legaldocument from './components/pages/Legaldocument';
import LandDeed from './components/pages/LandDeed';
import Plan from './components/pages/Plan';
import LetterHead from './components/pages/LetterHead';
import BankDetails from './components/pages/BankDetails';
import Photopage from './components/pages/Photopage';
import TrustDeed from './components/pages/TrustDeed';
import Itfiles from './components/pages/Itfile';
function App() {
  return (
     <Router>
    <div>
      <Routes>
      <Route axact path="/" element={<Home/>}/>
      <Route axact path="/governing-body" element={<Governing/>}/>
            <Route axact path="/Contactus" element={<Contactus/>}/>
             <Route axact path="/Pancard" element={<Pancard/>}/>
               <Route axact path="/aboutus" element={<About/>}/>
                 <Route axact path="/Deed" element={<Deed/>}/>
                   <Route axact path="/land-details" element={<LandDetails/>}/>
                      <Route axact path="/plan" element={<Plan/>}/>
                      <Route axact path="/LetterHead" element={<LetterHead/>}/> 
                          <Route axact path="/bank-details" element={<BankDetails/>}/> 
                     <Route axact path="/Legaldocument" element={<Legaldocument/>}/>
                                   <Route axact path="/photo" element={<Photopage/>}/>
           <Route axact path="/msmeitfile" element={<Itfiles/>}/>

                                             <Route axact path="/DeedofTrust" element={<TrustDeed/>}/>
                      <Route axact path="/land-deed" element={<LandDeed/>}/>
            </Routes>
    <Footer/>
  
    </div>

    </Router>
  );
}

export default App;
